import { useState, } from "react";
import Icons from "../myIcon/Icons";
import { Link } from "react-router-dom";
import React from "react";
import {
  brandOrderMap,
  byConfiguredOrder,
  byProductTitle,
  typeOrderMap,
} from "../helper/ProductMenuOrder";

export default function MobileMenu({ isOpen, setIsOpen, allData }) {
  const [isInner1, setIsInner1] = useState(false);
  const [isInner2, setIsInner2] = useState(false);
  const [isInner3, setIsInner3] = useState(false);
  const [isInner4, setIsInner4] = useState(false);
  const [isInner5, setIsInner5] = useState(false);

  const [level, setLevel] = useState(1);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeBrand, setActiveBrand] = useState(null);
  const [activeType, setActiveType] = useState(null);

  const handleLinkClick = () => {
    setIsOpen(false);
  };





  const categories = Object.entries(allData || {})
    .sort((a, b) => new Date(a[1]?.created_at || 0) - new Date(b[1]?.created_at || 0))
    .map(([key, value]) => ({
      name: key,
      slug: value.category_slug
    }));


  const getBackLabel = () => {
    if (level === 4) return "Types";
    if (level === 3) return "Brands";
    if (level === 2) return "Categories";
    return "";
  };

  return (
    <>
      <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
        <div className="mobilemenu-header">
          <Link to={"/"} onClick={handleLinkClick}><img src="/assets/images/header-logos.webp" alt="Supershine" className="img-responsive" /> </Link>
          <button className="menu-close-btn" onClick={() => { handleLinkClick(); setIsInner3(false); }} aria-label="Close menu">✕</button>
        </div>

        <ul className="mobile-mainmenu">
          <li><Link onClick={() => setIsInner1(true)}>company  <Icons name="arrowRight" /> </Link></li>
          <li><Link onClick={() => { setIsInner2(true); setLevel(1); }}>  Products <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner3(true)}>Services <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner4(true)}>Industries <Icons name="arrowRight" /></Link></li>
          <li><Link onClick={() => setIsInner5(true)}>Insights <Icons name="arrowRight" /></Link></li>
          {/* <li><Link to={"/contact"} onClick={handleLinkClick}>Contact Us</Link></li> */}
        </ul>

        <div className={isInner1 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner1(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>
            <div className="mobileinner-link">
              <li><Link to="/about" onClick={() => { handleLinkClick(); setIsInner1(false); }}>About Us</Link></li>
              <li><Link to="/contact" onClick={() => { handleLinkClick(); setIsInner1(false); }} >Contact</Link></li>
              <li><Link to="/about#our-team" onClick={() => { handleLinkClick(); setIsInner1(false); }} >Our Team</Link></li>
              <li><Link to="/careers" onClick={() => { handleLinkClick(); setIsInner1(false); }} >career</Link></li>
            </div>
          </div>
        </div>

        {/* <div className={isInner2 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
<div className="mobileinner-data">
<Link onClick={() => setIsInner2(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>
<div className="mobileinner-link">


<li> <Link to="/project-planing" onClick={() => { handleLinkClick(); setIsInner2(false); }}>Assessment & Project Planing  </Link>
</li>
<li> <Link to="/delivery" onClick={() => { handleLinkClick(); setIsInner2(false); }} > Delivery </Link> </li>
<li> <Link to="/installation" onClick={() => { handleLinkClick(); setIsInner2(false); }}  > Installation </Link> </li>
<li> <Link to="/training" onClick={() => { handleLinkClick(); setIsInner2(false); }} > Training </Link></li>
<li> <Link to="/sales-service" onClick={() => { handleLinkClick(); setIsInner2(false); }} > After Sales Service </Link></li>


<li><Link to="/project" onClick={() => { handleLinkClick(); setIsInner2(false); }}  >Projects</Link></li>
<li><Link to="/blog" onClick={() => { handleLinkClick(); setIsInner2(false); }}  >Blogs</Link></li>
<li><Link to="/news" onClick={() => { handleLinkClick(); setIsInner2(false); }}  >News</Link></li>
<li><Link to="/faq" onClick={() => { handleLinkClick(); setIsInner2(false); }}  >Faqs</Link></li>
<li><Link to="/privacy-policy" onClick={() => { handleLinkClick(); setIsInner2(false); }} >Privacy Policy</Link></li>

</div>
</div>
</div> */}

        <div className={isInner2 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">

            <Link
              onClick={() => {
                if (level === 4) {
                  setLevel(3); setActiveType(null);
                } else if (level === 3) {
                  setLevel(2); setActiveBrand(null);
                } else if (level === 2) {
                  setLevel(1); setActiveCategory(null);
                } else {
                  setIsInner2(false);
                }
              }} className="menu-back"  >
              <Icons name="arrowLeft" />
              {getBackLabel() ? ` Back to ${getBackLabel()}` : " Back"}
            </Link>

            <div className="mobileinner-link">
              {level === 1 &&
                categories
                  .filter((cat) => cat.name && cat.name.trim() !== "")
                  .map((cat, i) => (
                    <li key={i} className="category-child">
                      <Link to={cat.slug ? `/product-listing/${cat.slug}` : "#"} onClick={() => { handleLinkClick(); setIsInner2(false); }}   >   {cat.name}  </Link>
                      <button onClick={() => { setActiveCategory(cat.name); setLevel(2); }}>
                        <Icons name="arrowRight" />
                      </button>
                    </li>
                  ))}

              {/* LEVEL 2 → BRAND */}
              {level === 2 && activeCategory &&
                Object.keys(allData[activeCategory]?.brands || {})
                  .filter((brand) => brand && brand.trim() !== "")
                  .sort(byConfiguredOrder(brandOrderMap))
                  .map((brand, i) => (
                    <li key={i}>    <Link onClick={() => { setActiveBrand(brand); setLevel(3); }}>  {brand} <Icons name="arrowRight" /> </Link>
                    </li>
                  ))}

              {/* LEVEL 3 → TYPE */}
              {level === 3 && activeCategory && activeBrand &&
                Object.keys(allData[activeCategory]?.brands?.[activeBrand] || {})
                  .filter((type) => type && type.trim() !== "")
                  .sort(byConfiguredOrder(typeOrderMap))
                  .map((type, i) => (
                    <li key={i}>
                      <Link onClick={() => { setActiveType(type); setLevel(4); }}>
                        {type} <Icons name="arrowRight" />
                      </Link>
                    </li>
                  ))}

              {/* LEVEL 4 → PRODUCTS */}
              {level === 4 && activeCategory && activeBrand && activeType &&
                (allData[activeCategory]?.brands?.[activeBrand]?.[activeType] || [])
                  .filter((item) => item?.title && item.title.trim() !== "")
                  .sort(byProductTitle)
                  .map((item, i) => (
                    <li key={i}>
                      <Link to={`/product/${item.slug}`} onClick={() => { handleLinkClick(); setIsInner2(false); }}>
                        {item.title}
                      </Link>
                    </li>
                  ))}

            </div>
          </div>
        </div>

        <div className={isInner3 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner3(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>
            <div className="mobileinner-link">
              <li> <Link to="/project-planing" onClick={() => { handleLinkClick(); setIsInner3(false); }} >  Assessment & Project Planing  </Link> </li>
              <li> <Link to="/delivery" onClick={() => { handleLinkClick(); setIsInner3(false); }} > Delivery </Link> </li>
              <li> <Link to="/installation" onClick={() => { handleLinkClick(); setIsInner3(false); }} > Installation </Link> </li>
              <li> <Link to="/training" onClick={() => { handleLinkClick(); setIsInner3(false); }} > Training </Link></li>
              <li> <Link to="/sales-service" onClick={() => { handleLinkClick(); setIsInner3(false); }} > After Sales Service </Link></li>
            </div>
          </div>
        </div>

        <div className={isInner4 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner4(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>
            <div className="mobileinner-link">
              <li><Link to="/hospitality-laundry-washing-machine-system"  onClick={() => { handleLinkClick(); setIsInner4(false); }}>Hospitality</Link></li>
              <li><Link to="/heathcare-medical-grade-commercial-laundry" onClick={() => { handleLinkClick(); setIsInner4(false); }} >Healthcare</Link></li>
              <li><Link to="/pharmaceutical-grade-commercial-laundry" onClick={() => { handleLinkClick(); setIsInner4(false); }}  >Pharma</Link></li>
              <li><Link to="/commercial-washing-machine-for-university" onClick={() => { handleLinkClick(); setIsInner4(false); }}  >Education</Link></li>
              <li><Link to="/commercial-laundry-washing-machine" onClick={() => { handleLinkClick(); setIsInner4(false); }}>Commercial Laundry</Link></li>
              <li><Link to="/industrial-laundromat-washing-machines" onClick={() => { handleLinkClick(); setIsInner4(false); }} >Laundromat</Link></li>
              <li><Link to="/railway-grade-commercial-laundry-machine" onClick={() => { handleLinkClick(); setIsInner4(false); }} >Railways</Link></li>
              <li><Link to="/defence-grade-commercial-laundry-machine" onClick={() => { handleLinkClick(); setIsInner4(false); }} >Defence</Link></li>
              <li><Link to="/commercial-laundry-for-garment-manufacturing" onClick={() => { handleLinkClick(); setIsInner4(false); }} >Garments</Link></li>
            </div>
          </div>
        </div>
        <div className={isInner5 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
          <div className="mobileinner-data">
            <Link onClick={() => setIsInner5(false)} className="menu-back"><Icons name="arrowLeft" /> Back</Link>
            <div className="mobileinner-link">
              <li><Link to="/project" onClick={() => { handleLinkClick(); setIsInner5(false); }}  >Projects</Link></li>
              <li><Link to="/blog" onClick={() => { handleLinkClick(); setIsInner5(false); }} >Blogs</Link></li>
              <li><Link to="/news" onClick={() => { handleLinkClick(); setIsInner5(false); }} >News</Link></li>
              <li><Link to="/faq" onClick={() => { handleLinkClick(); setIsInner5(false); }} >Faqs</Link></li>
              <li><Link to="/privacy-policy" onClick={() => { handleLinkClick(); setIsInner5(false); }} >Privacy Policy</Link></li>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
